export interface ComparisonRow {
  before: string
  after: string
}

export const transformationRows: ComparisonRow[] = [
  {
    before:
      'Vendu à la séance : le client redécide à chaque fois s’il revient',
    after:
      'Un parcours de dix séances, présenté dès la séance découverte par ce qu’il contient',
  },
  {
    before: 'De bonnes séances, sans fil entre elles',
    after: 'Une feuille de route co-construite, un jalon par phase',
  },
  {
    before: 'La quatrième séance arrive par surprise',
    after: 'Le creux est annoncé en séance 3 et devient un passage de phase',
  },
  {
    before: 'La crainte d’être confondu(e) avec un gourou',
    after:
      'Un cadre écrit : contrat, déontologie, fiche d’orientation, une fin claire',
  },
  {
    before: 'Le parcours s’éteint sans bilan',
    after:
      'Un bilan de clôture formulé par le client, qui sait dire ce qu’il a obtenu',
  },
  {
    before: 'Un(e) coach formé(e) qui doute de sa légitimité',
    after:
      'Un(e) coach professionnel(le) qui a un cadre, une méthode, une déontologie',
  },
]

export const costRows: ComparisonRow[] = [
  {
    before: 'Un parcours qui s’arrête à la séance 3 ou 4',
    after:
      'Un client qui repart sans pouvoir dire ce qu’il a obtenu — et qui ne recommande pas',
  },
  {
    before: 'Des séances sans feuille de route',
    after:
      'Des clients qui concluent que « ça ne marche pas », alors que le progrès existait',
  },
  {
    before:
      'Des fiches, des e-mails et des trames refaits pour chaque nouveau client',
    after: 'Des soirées de préparation qui ne sont pas facturées',
  },
  {
    before: 'Aucun contrat clair ni conditions générales',
    after: 'Une demande de remboursement ou un litige, sans cadre pour y répondre',
  },
  {
    before: 'La quatrième séance vécue seul(e), sans repère',
    after: 'Le doute sur sa propre légitimité, un parcours après l’autre',
  },
]

export const closeRows: ComparisonRow[] = [
  {
    before: 'Improviser chaque séance et espérer que le client revienne',
    after: 'Suivre une feuille de route, séance par séance',
  },
  {
    before: 'Vendre des séances, une par une',
    after: 'Présenter un parcours, par ce qu’il contient',
  },
  {
    before: 'Tout reconstruire pour chaque nouveau client',
    after: 'Ouvrir le tome. Suivre la trame. L’adapter à sa voix.',
  },
]
